import theme from '../../../../lib/theme';
import { FabProps } from './Fab';

const { colors, layouts, corners, scale, font } = theme;

export default ({
  size = 'm',
  brand = 'sas',
  color = 'primary',
  iconColor = 'light_grey',
}: FabProps) => ({
  container: {
    ...layouts.center,

    backgroundColor: colors[color] || colors[brand][color],
    width: scale[size],
    height: scale[size],
    borderRadius: corners.f,
    border: 'none',
    cursor: 'pointer',
    textDecoration: 'none !important',
    transition: 'all 0.25s ease',

    '&:hover': {
      color: color === 'primary' ? colors.white : colors.sas.primary,
      backgroundColor: colors[brand].secondary,
    },

    '&:focus': {
      color: color === 'primary' ? colors.white : colors.sas.primary,
    },

    '& > i': {
      fontSize: size === 's' ? font.m : '24px',
      color: colors[iconColor] || colors[brand][iconColor],
    },
  },
});
